import { render, staticRenderFns } from "./WeekPeriodRule.vue?vue&type=template&id=54a97db6&scoped=true"
import script from "./WeekPeriodRule.vue?vue&type=script&lang=js"
export * from "./WeekPeriodRule.vue?vue&type=script&lang=js"
import style0 from "./WeekPeriodRule.vue?vue&type=style&index=0&id=54a97db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a97db6",
  null
  
)

export default component.exports